import React from 'react';
import { ArticleSection } from './ArticleSection';
import { ExternalLink } from '../ExternalLink';
import { contextualLinks } from '../../data/site';
export function AiAgentsSection() {
  const link = contextualLinks.agentsCanada;
  return <ArticleSection id="ai-agents" title="AI Agents and Autonomous Workflows" data-id="element-1" data-mp="gyp0ccpwanha">
      <p data-id="element-2" data-mp="c1othzl81gp4">
        An AI agent is software that pursues a goal across several steps: it plans, calls tools or APIs,
        checks the result and decides what to do next. In workflow automation, agents take over the
        connective tissue between systems, the work people used to do by copying data between tabs and
        chasing updates by email.
      </p>
      <p data-id="element-3" data-mp="3pfjriuxbyjfj">
        The practical question is not whether agents are capable, but how much autonomy they should have.
        The most reliable deployments give each agent a narrow responsibility, a limited set of permitted
        tools and clear escalation rules. An agent might prepare a refund decision with the evidence
        attached; a person approves anything above an agreed threshold.
      </p>
      <ul className="bullets" data-id="element-4" data-mp="1cn4vig5jikcp">
        <li data-id="element-5" data-mp="1cmdau0dhe717"><strong data-id="element-6" data-mp="1cm3kucsfrzvi">Scoped permissions:</strong> agents can only read and write what their task requires.</li>
        <li data-id="element-7" data-mp="1hewmuswisu3w"><strong data-id="element-8" data-mp="1hf6gqrkorlev">Observable reasoning:</strong> every action is logged so reviewers can see why it happened.</li>
        <li data-id="element-9" data-mp="1li2r5v02ob7q"><strong data-id="element-10" data-mp="1li2vu8b0oze2">Graceful fallback:</strong> low-confidence cases route to a person instead of guessing.</li>
      </ul>
      <p data-id="element-11" data-mp="tosjmmn8uwdf">
        Agent orchestration is evolving quickly on both sides of the Atlantic. If you are benchmarking
        specialists internationally, it is worth reviewing{' '}
        <ExternalLink href={link.href} data-id="element-12" data-mp="xsia5hnhbo13">{link.anchor}</ExternalLink>, where many teams are working through the
        same questions of autonomy, tooling and oversight.
      </p>
    </ArticleSection>;
}